import authType from "./revenueSettingsTypes";

const initialState = {
  isLoading: false,
  searching: false,
  filtering: false,
  downloading: false,
  search: [],
  myReferrals: {},
  allRevenueSettings: {},
};

export default function revenueSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case authType.LOADING_REFERRALS:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case authType.GET_MY_REFERRALS:
      return {
        ...state,
        myReferrals: action.payLoad?.data,
      };

    case authType.ALL_REFERRALS:
      return {
        ...state,
        allRevenueSettings: action.payLoad?.data,
      };

    case authType.SEARCHING:
      return {
        ...state,
        searching: action.payLoad,
      };

    case authType.SEARCH_REFERRALS:
      return {
        ...state,
        search: action.payLoad,
      };

    case authType.REVENUE_SETTINGS_FILTERING:
      return {
        ...state,
        filtering: action.payLoad,
      };

    case authType.REVENUE_SETTINGS_FILTER:
      return {
        ...state,
        allRevenueSettings: action.payLoad?.data,
      };

    case authType.DOWNLOADING:
      return {
        ...state,
        downloading: action.payLoad,
      };

    default:
      return state;
  }
}
